import { CSSProperties, useEffect, useState } from 'react'
import { theme } from 'antd'
import { gold } from '@ant-design/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { Coaching } from '../inputSanityModel'
import './CoachingDisclosure.css'

type Props = {
  coaching: Coaching
}

const CoachingDisclosure = ({ coaching }: Props) => {
  const { token } = theme.useToken()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(false)
  }, [coaching.objection])

  const palette = {
    '--coaching-color': gold[7],
    '--coaching-color-hover': gold[8],
    '--coaching-bg': token.colorWarningBg,
    '--coaching-border': token.colorWarningBorder,
    '--coaching-body': token.colorText,
    '--coaching-gap': `${token.marginXXS}px`,
    '--coaching-padding': `${token.paddingSM}px`,
    '--coaching-radius': `${token.borderRadius}px`,
    '--coaching-font-size': `${token.fontSizeSM}px`
  } as CSSProperties

  return (
    <div className="coaching-disclosure" style={palette}>
      <button
        type="button"
        className="coaching-disclosure-objection"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {coaching.objection}
        <FontAwesomeIcon
          icon={faChevronDown}
          size="xs"
          className={open ? 'coaching-disclosure-chevron-open' : undefined}
        />
      </button>

      {open && (
        <div className="coaching-disclosure-body">
          {coaching.body.map(paragraph => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      )}
    </div>
  )
}

export default CoachingDisclosure
